// extracted by mini-css-extract-plugin
export default {"fullMaxWidth":"XJ-z","carouselContainer":"YJ-z"};